<template>
  <div>
    <BaseAvatar
      :initials="location?.initials ?? '##'"
      :ring-color="ringColor"
      :border-color="borderColorComputed"
      :shadow-color="shadowColor"
      :size="size"
      :img-url="location?.logo_url ?? null"
      hide-status
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseAvatar from '@c/Avatar/BaseAvatar.vue'

export default {
  name: 'LocationAvatar',
  components: { BaseAvatar },
  props: {
    id: {
      type: String,
      required: true
    },
    ringColor: {
      type: String,
      required: false,
      default: null
    },
    shadowColor: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) =>
        ['extra-small', 'small', 'medium', 'large', 'extra-large'].indexOf(
          value
        ) !== -1
    }
  },
  computed: {
    ...mapGetters({
      getLocation: 'metadata/getLocationMetadata'
    }),
    location() {
      return this.getLocation(this.id)
    },
    borderColorComputed() {
      if (this.disponibility) {
        switch (this.disponibility) {
          case 'pending':
            return 'border-yellow-400'
          case 'confirmed':
            return 'border-green-500'
          case 'refused':
            return 'border-red-500'
        }
      }
      return 'border-white'
    }
  }
}
</script>
